import styled from '@emotion/styled';

export const Wrapper = styled.div`
  padding: 50px 0px;
  background: ${(props) => props.theme.color.blue.default};
`;

export const JoinMore = styled.div`
  margin-bottom: 30px;
`;

export const StatusText = styled.div`
  background: ${(props) => props.theme.color.green.default};
  color: ${(props) => props.theme.color.light.default};

  font-size: 16px;
  font-weight: 700;

  display: flex;
  justify-content: center;
  align-items: center;

  border-radius: 10px;
  margin: 30px auto;
  padding: 8px 15px;
`;

export const DismissIconWrapper = styled.div`
  font-size: 18px;
  cursor: pointer;
  margin: 5px;
`;
